import React from 'react';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';

import ErrorPage from '@components/ErrorPage';

import LoginPage from './LoginPage';

import './style.scss';

interface IAgencyUserSetupProps {}

interface IAgencyUserSetupState extends RouteComponentProps<{ agencyId: string }> {}

class AgencyUserSetup extends React.Component<IAgencyUserSetupState, IAgencyUserSetupProps> {
  render() {
    return (
      <div className="agency-user-setup-container">
        {!this.props.location.pathname.includes('login') && (
          <header className="app-header">
            <img alt="agency_logo" src="/assets/logo_white.png" />
          </header>
        )}
        <main>
          <Switch>
            <Route exact path="/agencies/:agencyId/error" component={ErrorPage} />
            <Route exact path="/agencies/:agencyId/login" component={LoginPage} />
          </Switch>
        </main>
      </div>
    );
  }
}

export default withRouter(AgencyUserSetup);
